module.exports = __webpack_public_path__ + "cc35a0ca480157098e56944d1db0a5a7.pdf";